import React from 'react';
import { REGULATORY } from '@/constants/content';
import { Shield, FileCheck, Inbox, Award, ShieldCheck, Lock, FileSignature } from 'lucide-react';

const iconMap = {
  Shield: Shield,
  FileCheck: FileCheck,
  Inbox: Inbox,
  Award: Award,
  ShieldCheck: ShieldCheck,
  Lock: Lock,
  FileSignature: FileSignature,
};

const certIconMap = {
  'award': Award,
  'shield-check': ShieldCheck,
  'lock': Lock,
  'file-signature': FileSignature,
};

export const RegulatoryCompliance = () => {
  return (
    <section
      id="normatividad"
      className="py-20 lg:py-32"
      style={{ background: 'linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)' }}
      data-testid="regulatory-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="regulatory-title"
          >
            {REGULATORY.title}
          </h2>
          <p className="text-lg text-gray-600" data-testid="regulatory-subtitle">
            {REGULATORY.subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16" data-testid="regulatory-features">
          {REGULATORY.features.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <article
                key={feature.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-100"
                data-testid={`regulatory-feature-${feature.id}`}
              >
                <div className="mb-6">
                  <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center">
                    <Icon className="w-7 h-7 text-blue-700" />
                  </div>
                </div>
                <h3
                  className="text-xl font-bold text-gray-900 mb-3"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                  data-testid={`regulatory-feature-title-${feature.id}`}
                >
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </article>
            );
          })}
        </div>

        {/* Certifications Bar */}
        <div
          className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 lg:p-12"
          data-testid="certifications-bar"
        >
          {/* Title and Subtitle - Centered at Top */}
          <div className="text-center text-white mb-8">
            <h3
              className="text-2xl lg:text-3xl font-bold mb-2"
              style={{ fontFamily: 'Manrope, sans-serif' }}
              data-testid="certifications-title"
            >
              Cumplimiento Normativo
            </h3>
            <p className="text-blue-100 text-base" data-testid="certifications-subtitle">
              Normativas y estándares que te respaldan
            </p>
          </div>

          {/* Certifications Grid - 4 columns, 2 rows */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
            {REGULATORY.certifications.map((cert) => {
              const CertIcon = certIconMap[cert.icon];
              return (
                <div
                  key={cert.name}
                  className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 hover:bg-white/20 transition-colors duration-200"
                  data-testid={`certification-${cert.name.toLowerCase().replace(/\s/g, '-')}`}
                >
                  <CertIcon className="w-5 h-5 text-white flex-shrink-0" />
                  <span className="text-white font-medium text-sm">
                    {cert.name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};